var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseEnterprise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55 51.5H1V49.7439H55V51.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.45652 5.2561V49.7439H32.1087V5.2561H7.45652ZM6.86957 3.5C6.22123 3.5 5.69565 4.02415 5.69565 4.67073V50.3293C5.69565 50.9758 6.22123 51.5 6.86957 51.5H32.6957C33.344 51.5 33.8696 50.9758 33.8696 50.3293V4.67073C33.8696 4.02415 33.344 3.5 32.6957 3.5H6.86957Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0217 45.061V49.7439H21.5435V45.061H18.0217ZM17.4348 43.3049C16.7864 43.3049 16.2609 43.829 16.2609 44.4756V50.3293C16.2609 50.9758 16.7864 51.5 17.4348 51.5H22.1304C22.7788 51.5 23.3043 50.9758 23.3043 50.3293V44.4756C23.3043 43.829 22.7788 43.3049 22.1304 43.3049H17.4348Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5652 35.1098C12.2136 35.1098 12.7391 35.6339 12.7391 36.2805V37.4512C12.7391 38.0978 12.2136 38.6219 11.5652 38.6219C10.9169 38.6219 10.3913 38.0978 10.3913 37.4512V36.2805C10.3913 35.6339 10.9169 35.1098 11.5652 35.1098Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5652 26.9146C12.2136 26.9146 12.7391 27.4388 12.7391 28.0854V29.2561C12.7391 29.9027 12.2136 30.4268 11.5652 30.4268C10.9169 30.4268 10.3913 29.9027 10.3913 29.2561V28.0854C10.3913 27.4388 10.9169 26.9146 11.5652 26.9146Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5652 18.7195C12.2136 18.7195 12.7391 19.2437 12.7391 19.8902V21.061C12.7391 21.7076 12.2136 22.2317 11.5652 22.2317C10.9169 22.2317 10.3913 21.7076 10.3913 21.061V19.8902C10.3913 19.2437 10.9169 18.7195 11.5652 18.7195Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5652 10.5244C12.2136 10.5244 12.7391 11.0485 12.7391 11.6951V12.8659C12.7391 13.5124 12.2136 14.0366 11.5652 14.0366C10.9169 14.0366 10.3913 13.5124 10.3913 12.8659V11.6951C10.3913 11.0485 10.9169 10.5244 11.5652 10.5244Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7826 35.1098C20.4309 35.1098 20.9565 35.6339 20.9565 36.2805V37.4512C20.9565 38.0978 20.4309 38.6219 19.7826 38.6219C19.1343 38.6219 18.6087 38.0978 18.6087 37.4512V36.2805C18.6087 35.6339 19.1343 35.1098 19.7826 35.1098Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7826 26.9146C20.4309 26.9146 20.9565 27.4388 20.9565 28.0854V29.2561C20.9565 29.9027 20.4309 30.4268 19.7826 30.4268C19.1343 30.4268 18.6087 29.9027 18.6087 29.2561V28.0854C18.6087 27.4388 19.1343 26.9146 19.7826 26.9146Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7826 18.7195C20.4309 18.7195 20.9565 19.2437 20.9565 19.8902V21.061C20.9565 21.7076 20.4309 22.2317 19.7826 22.2317C19.1343 22.2317 18.6087 21.7076 18.6087 21.061V19.8902C18.6087 19.2437 19.1343 18.7195 19.7826 18.7195Z",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7826 10.5244C20.4309 10.5244 20.9565 11.0485 20.9565 11.6951V12.8659C20.9565 13.5124 20.4309 14.0366 19.7826 14.0366C19.1343 14.0366 18.6087 13.5124 18.6087 12.8659V11.6951C18.6087 11.0485 19.1343 10.5244 19.7826 10.5244Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 35.1098C28.6483 35.1098 29.1739 35.6339 29.1739 36.2805V37.4512C29.1739 38.0978 28.6483 38.6219 28 38.6219C27.3517 38.6219 26.8261 38.0978 26.8261 37.4512V36.2805C26.8261 35.6339 27.3517 35.1098 28 35.1098Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 26.9146C28.6483 26.9146 29.1739 27.4388 29.1739 28.0854V29.2561C29.1739 29.9027 28.6483 30.4268 28 30.4268C27.3517 30.4268 26.8261 29.9027 26.8261 29.2561V28.0854C26.8261 27.4388 27.3517 26.9146 28 26.9146Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 18.7195C28.6483 18.7195 29.1739 19.2437 29.1739 19.8902V21.061C29.1739 21.7076 28.6483 22.2317 28 22.2317C27.3517 22.2317 26.8261 21.7076 26.8261 21.061V19.8902C26.8261 19.2437 27.3517 18.7195 28 18.7195Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 10.5244C28.6483 10.5244 29.1739 11.0485 29.1739 11.6951V12.8659C29.1739 13.5124 28.6483 14.0366 28 14.0366C27.3517 14.0366 26.8261 13.5124 26.8261 12.8659V11.6951C26.8261 11.0485 27.3517 10.5244 28 10.5244Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4348 50.3293V39.7927H46.1957V50.3293H44.4348Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7174 39.2073V38.0366C49.7174 35.4503 47.6151 33.3537 45.0217 33.3537C42.4284 33.3537 40.3261 35.4503 40.3261 38.0366V39.2073C40.3261 41.7936 42.4284 43.8902 45.0217 43.8902C47.6151 43.8902 49.7174 41.7936 49.7174 39.2073ZM45.0217 31.5976C41.4559 31.5976 38.5652 34.4804 38.5652 38.0366V39.2073C38.5652 42.7635 41.4559 45.6463 45.0217 45.6463C48.5876 45.6463 51.4783 42.7635 51.4783 39.2073V38.0366C51.4783 34.4804 48.5876 31.5976 45.0217 31.5976Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseEnterprise);
export default __webpack_public_path__ + "static/media/house-enterprise.825c4fd449188d0adf284e6ac300508b.svg";
export { ForwardRef as ReactComponent };